module.exports = __webpack_public_path__ + "static/media/centro_platea_1.08f6dc9d.mp4";